'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'comment';
var width = 512;
var height = 512;
var aliases = [128489,61669];
var unicode = 'f075';
var svgPathData = 'M142.4 417.2c4.3-3.1 9.9-3.9 14.9-2.1c30 10.9 63.4 17 98.7 17c135.8 0 240-88.9 240-192S391.8 48 256 48S16 136.9 16 240c0 40.7 15.9 78.8 43.7 110.3c2.9 3.2 4.3 7.5 3.9 11.8c-2.2 27.7-12.9 52-23.6 69.9c-6 10-12 18-16.5 23.5l-12.2-10 12.2 10c-2.2 2.7-4.1 4.9-5.4 6.3c-.7 .7-1.2 1.3-1.5 1.6c0 0 0 0-.1 .1l-.3 .3c0 0 0 0 0 0s0 0 0 0L16 464c25.6 0 52.3-8 75.2-18c21.8-9.5 40.3-20.9 51.2-28.8zM4.7 452.7s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComment = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;